/*
Finishes for Metal
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Finishes for Metal'
const id = 'esFj75u9cTcGOVXs8ett'

export default {
  name,
  id,
  filters,
  headers,
  form
}
